module.exports = __webpack_public_path__ + "img/emoji_15.dc0dc442.png";